import { KineticLine, Reveal } from "@/components/Kinetic";

const CHAPTERS = [
  {
    num: "01",
    title: "The Name",
    body: "Always & Forever started as a signature and became a promise. Founded by Monica Alexander in Chicago, every piece carries the same embroidered script — a love letter stitched into fleece.",
  },
  {
    num: "02",
    title: "The Craft",
    body: "Two processes, zero shortcuts. Dye-sublimation fuses the artwork into the fabric itself — it cannot crack or peel. Our varsity jackets are hand-airbrushed in single sessions, sealed, and finished by hand.",
  },
  {
    num: "03",
    title: "The City",
    body: "Shot at night under the neon at The Basement. Chicago raised this brand — the skyline drip on our varsity, the grit in our fleece, the loyalty in our name.",
  },
  {
    num: "04",
    title: "The Price",
    body: "No mystery markups. Every product lists its true production cost — blanks, print run, press and airbrush labor — so you know exactly what you're paying for and why.",
  },
];

export default function Manifesto() {
  return (
    <section id="craft" className="px-5 sm:px-10 py-28 sm:py-40 border-t border-white/10">
      <Reveal>
        <p className="text-[11px] uppercase tracking-[0.3em] text-white/40 mb-16">The Manifesto</p>
      </Reveal>

      <div className="flex flex-col">
        {CHAPTERS.map((c, i) => (
          <div
            key={c.num}
            data-testid={`manifesto-chapter-${c.num}`}
            className={`flex flex-col md:flex-row gap-6 md:gap-16 py-14 sm:py-20 border-t border-white/10 ${i % 2 === 1 ? "md:flex-row-reverse md:text-right" : ""}`}
          >
            <Reveal className="md:w-1/3 shrink-0">
              <span className="font-unbounded font-extrabold text-7xl sm:text-8xl lg:text-9xl text-outline-pink leading-none">
                {c.num}
              </span>
            </Reveal>
            <div className="md:w-2/3">
              <h3 className="font-display font-medium uppercase tracking-tight text-3xl sm:text-4xl lg:text-5xl mb-6">
                <KineticLine inView>{c.title}</KineticLine>
              </h3>
              <Reveal delay={0.15}>
                <p className={`text-base sm:text-lg text-white/55 font-light leading-relaxed max-w-xl ${i % 2 === 1 ? "md:ml-auto" : ""}`}>
                  {c.body}
                </p>
              </Reveal>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
